import { createContext } from 'react';

// {tasks, toasts} - see ActiveTasksProvider.jsx for the actual task-running/
// WS/notification logic. Split into its own file the same way
// PendingApprovalsContext.jsx is, so any component can import just the
// context without pulling in the provider's implementation.
const ActiveTasksContext = createContext({
   tasks: [],
   toasts: [],
   startQuizGenerationTask: () => {},
   dismissTask: () => {},
   dismissToast: () => {},
});

export default ActiveTasksContext;
